'use strict'

var PrimaryNavToggler = function(el) {
	this.el = el;
	this.$el = $(el);
	this.$el.data('PrimaryNavToggler', this)
}

var EVENT_NS = '.primary-nav-toggler'
var EVENT_TOGGLE = PrimaryNavToggler.EVENT_TOGGLE = 'toggle' + EVENT_NS

Object.assign(PrimaryNavToggler.prototype, {
	init: function() {
		this.attachEventHandlers()
		return this
	},
	attachEventHandlers: function() {
		$(this.el).on('click', $.proxy(this.onClick, this))
	},
	toggle: function(open, options) {
		this.$el.toggleClass('open', open)
		var silent = options && options.silent
		if (!silent) {
			this.$el.trigger(EVENT_TOGGLE)
		}
	},
	isOpen: function() {
		return this.$el.hasClass('open')
	},
	onClick: function(event) {
		event.stopPropagation()
		this.toggle()
	}
})

module.exports = PrimaryNavToggler


/*****************
 ** WEBPACK FOOTER
 ** ./components/PrimaryNavToggler.js
 ** module id = 160
 ** module chunks = 0
 **/